import { Badge } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";
import type { OrderInvoiceSummary } from "@models/order";

interface InvoiceVoidedBadgeProps {
    // The order's invoice as the order reads expose it; `null` = none issued.
    invoice: OrderInvoiceSummary | null;
}

// The VOIDED mark the order pages (#214/#216) render beside InvoiceDownload
// for a voided invoice (#217), which still downloads — as `-VOID.pdf`.
// Separate from InvoiceDownload so a host with its own status badge (the
// Billing History card, #215) simply does not render it. Nothing for a live
// invoice or none; `voidedAt` is read truthily, as InvoiceDownload reads it.
export const InvoiceVoidedBadge = ({ invoice }: InvoiceVoidedBadgeProps) =>
    invoice?.voidedAt ? (
        <Badge
            color={ComponentColor.Error}
            size={ComponentSize.SM}
            outline
            title="This invoice was voided. The download is the original PDF, named -VOID."
        >
            VOIDED
        </Badge>
    ) : null;
